import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, interval } from 'rxjs';

import { MaintenanceService } from '../../maintenance.service';
import {
  MaintenanceState,
  formatCountdown,
  formatAbsoluteTime,
  msUntilEnd,
} from '../../models/maintenance-state.model';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit, OnDestroy {

  state: MaintenanceState | null = null;
  countdown = '--:--';
  absoluteTime = '--:--';
  isBack = false;

  private _stateSub: Subscription | null = null;
  private _tickSub: Subscription | null = null;
  private _redirectTimer: any = null;

  constructor(
    private maintenanceService: MaintenanceService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // Redireciona imediatamente se o sistema já estiver normal
    const current = this.maintenanceService.currentState();
    if (current && current.phase === 'normal') {
      this.router.navigate(['/login']);
      return;
    }

    history.replaceState(null, '', '/maintenance');

    this._stateSub = this.maintenanceService.state$.subscribe((state) => {
      this.state = state;

      if (!state || state.phase === 'maintenance') return;

      // Qualquer fase que não seja maintenance libera o sistema.
      // normal    → redirect com cache-bust para garantir build atualizado
      // scheduled / winding_down → navega para /home via router (sem hard reload),
      //             o banner aparecerá no topo avisando o usuário
      if (state.phase === 'normal') {
        this._onSystemBack();
      } else {
        // scheduled ou winding_down: sistema voltou mas com manutenção ainda prevista
        this._onSystemPartialBack();
      }
    });

    // Ticker a cada 1s para atualizar countdown
    this._tickSub = interval(1000).subscribe(() => this._updateCountdown());
    this._updateCountdown();
  }

  ngOnDestroy(): void {
    this._stateSub?.unsubscribe();
    this._tickSub?.unsubscribe();
    if (this._redirectTimer) clearTimeout(this._redirectTimer);
  }

  reload(): void {
    window.location.reload();
  }

  private _updateCountdown(): void {
    if (!this.state) return;
    const ms = msUntilEnd(this.state);
    this.countdown = formatCountdown(ms);
    this.absoluteTime = formatAbsoluteTime(this.state.endsAt);
  }

  private _onSystemBack(): void {
    if (this.isBack) return;
    this.isBack = true;
    this._tickSub?.unsubscribe();
    // Hard reload com cache-bust: garante que o usuário recebe o build mais recente
    this._redirectTimer = setTimeout(() => {
      window.location.href = '/login?v=' + Date.now();
    }, 2000);
  }

  private _onSystemPartialBack(): void {
    if (this.isBack) return;
    this.isBack = true;
    this._tickSub?.unsubscribe();
    // Sistema voltou mas manutenção ainda está prevista (scheduled/winding_down).
    // Navega via router para /home — banner aparecerá avisando o usuário.
    this._redirectTimer = setTimeout(() => {
      this.router.navigate(['/home']);
    }, 2000);
  }
}
